/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Compensation } from './Compensation';
import type { NoticesRecipient } from './NoticesRecipient';
import type { OtherProp } from './OtherProp';
import type { PaymentInstructions } from './PaymentInstructions';
import type { TImageLocation } from './TImageLocation';
import type { TimeLog } from './TimeLog';
import type { WardrobeCounts } from './WardrobeCounts';
/**
 * Make all properties in T optional
 */
export type Partial_Omit_TCreatePerformerContractRequest_performerId_or_projectId_or_contractType__ = {
    commercialIds?: Array<string>;
    location_id?: string;
    contractDayAndMonth?: string;
    contractTwoDigitYear?: string;
    producerName?: string;
    agencyName?: string;
    agencyAddress?: string;
    producerAddress?: string;
    advertiserName?: string;
    productName?: string;
    advertiserAndProduct?: string;
    commercialTitlesAndAdIds?: string;
    numberOfCommercials?: number;
    numberOfTags?: number;
    classification?: Partial_Omit_TCreatePerformerContractRequest_performerId_or_projectId_or_contractType__.classification;
    roleId?: string;
    partToBePlayed?: string;
    cityAndState?: string;
    placeOfEngagement?: string;
    dateAndHoursOfEmployment?: string;
    compensation?: Array<Compensation>;
    hazardAdjustment?: string;
    usage_guarantee_amount?: number;
    isWardrobeFurnishedByPerformer?: boolean;
    isWardrobeFurnishedByProducer?: boolean;
    isJpcAuthorizerAgencyOrAdvertiser?: boolean;
    isOnCamera?: boolean;
    isOffCamera?: boolean;
    isPrincipalPerformer?: boolean;
    isStuntPerformer?: boolean;
    isSpecialtyAct?: boolean;
    isPilot?: boolean;
    isStuntCoordinator?: boolean;
    isDancerSoloOrDuo?: boolean;
    isDancer3Plus?: boolean;
    isSingerSoloOrDuo?: boolean;
    isGroupSinger3To5?: boolean;
    isGroupSinger6To8?: boolean;
    isGroupSinger9Plus?: boolean;
    isContractor?: boolean;
    isPaymentToPerformer?: boolean;
    isPaymentToAgent?: boolean;
    isSeasonal?: boolean;
    isTestOrTestMarket?: boolean;
    isNonAir?: boolean;
    isTraditionalDigital?: boolean;
    isTheatricalIndustrial?: boolean;
    isForeignLanguageTranslation?: boolean;
    wardrobeCounts?: WardrobeCounts;
    wardrobeFeeTotal?: string;
    travelZoneAllowance?: number;
    tolls?: string;
    mileage?: string;
    parking?: string;
    vehicleType?: string;
    flightInsuranceOptIn?: boolean;
    propsUsed?: Array<string>;
    otherProp?: OtherProp;
    adjustments?: Array<string>;
    nightPremium?: boolean;
    paymentInstructions?: PaymentInstructions;
    noticesRecipient?: NoticesRecipient;
    employerOfRecordNameAndAddress?: string;
    specialProvisions?: string;
    timeLogs?: Array<TimeLog>;
    isMultipleTrackingOrSweetening?: boolean;
    parentOrGuardian?: string;
    characterPhotos?: Array<TImageLocation>;
};
export namespace Partial_Omit_TCreatePerformerContractRequest_performerId_or_projectId_or_contractType__ {
    export enum classification {
        ON_CAMERA = 'on_camera',
        OFF_CAMERA = 'off_camera',
    }
}

